import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const NoEventsIcon = RESIDENTS_SVG_COMPONENTS.NO_EVENTS_ICON;

interface EventGlassEmptyStateProps {
  title: string;
  message: string;
}

export const EventGlassEmptyState: React.FC<EventGlassEmptyStateProps> = React.memo(({ title, message }) => {
  const { colors } = useThemeColors();
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <NoEventsIcon width={68} height={68} color={colors.text.dimmer} />
      </View>
      <View style={styles.textContainer}>
        <Text style={[styles.title, { color: colors.text.primary }]}>{title}</Text>
        <Text style={[styles.message, { color: colors.text.muted }]}>{message}</Text>
      </View>
    </View>
  );
});

EventGlassEmptyState.displayName = 'EventGlassEmptyState';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 40,
    paddingVertical: 65,
    gap: 18,
  },
  iconContainer: {
    width: 68,
    height: 68,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
    width: 260,
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.cardTitleLarge,
    lineHeight: 24,
    textAlign: 'center',
  },
  message: {
    ...REDESIGN_TYPOGRAPHY.body,
    lineHeight: 21,
    textAlign: 'center',
  },
});
